var React = require('react');

function ChatCloudRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M63.1532 2.98886C28.8512 2.98886 3 27.9475 3 63.1881V110.147C3 140.769 26.9331 170.443 63.1532 170.443H73.6307C83.0403 170.443 96.0192 175.85 102.637 182.559L168.993 249.851C175.61 256.56 182.398 254.47 184.188 245.222L195.302 187.188C197.092 177.94 204.999 170.443 212.949 170.443H454.846C491.898 170.443 515 143.564 515 110.147V63.1881C515 26.9453 490.065 2.98886 454.846 2.98886H63.1532Z","stroke":"white","strokeWidth":"5"}));
}

ChatCloudRightInline.defaultProps = {"width":"518","height":"257","viewBox":"0 0 518 257","fill":"none"};

module.exports = ChatCloudRightInline;

ChatCloudRightInline.default = ChatCloudRightInline;
